<div class="ion-page" main>
  @if (reportId !== null) {
    <ion-content id="content">
      @if (!isInTestMode) {
        <app-embedding-report [reportId]="reportId" [reportType]="reportType" [dashboardGroupId]="groupId"></app-embedding-report>
      }
      @if (isInTestMode) {
        <app-embedding-report-testing [reportId]="reportId" [reportType]="reportType" [groupId]="groupId" [RLSInput]="RLSFilterText"></app-embedding-report-testing>
      }
    </ion-content>
  }
</div>


